import { useRef } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { generateId } from 'utilities/uniqueId'

type Props = {
  label: string
  onRemove?: () => void
  disabledTooltip?: string
}

export const RemovableChip = ({ label, onRemove, disabledTooltip }: Props) => {
  const tooltipId = useRef(`chip-tooltip-${generateId()}`).current

  const removeButton = disabledTooltip ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={tooltipId}>{disabledTooltip}</Tooltip>}
    >
      <span
        className="ml-xs grey-30 font-size-18 line-height-1"
        style={{ cursor: 'not-allowed' }}
        tabIndex={0}
        aria-label={disabledTooltip}
      >
        <span aria-hidden="true">&times;</span>
      </span>
    </OverlayTrigger>
  ) : onRemove ? (
    <button
      type="button"
      onClick={onRemove}
      aria-label={`Remove ${label}`}
      className="border-0 bg-transparent p-0 ml-xs cursor-pointer grey-50 font-size-18 line-height-1"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  ) : null

  return (
    <span className="d-inline-flex align-items-center border rounded bg-white px-s py-xs grey-70 font-size-14">
      {label}
      {removeButton}
    </span>
  )
}
